import { render, staticRenderFns } from "./Answer.vue?vue&type=template&id=4281df5e&scoped=true"
import script from "./Answer.vue?vue&type=script&lang=js"
export * from "./Answer.vue?vue&type=script&lang=js"
import style0 from "./Answer.vue?vue&type=style&index=0&id=4281df5e&prod&lang=css"
import style1 from "./Answer.vue?vue&type=style&index=1&id=4281df5e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4281df5e",
  null
  
)

export default component.exports